import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Type } from "@themes/pollinator/ui/Type";
import { Button } from "@themes/pollinator/ui/Button";
import { ForgotPasswordFormContainer } from "@platform/features/auth";
import { AuthPageContent } from "@themes/pollinator/ui/AuthPageContent";

export function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);

  const onCancel = () => {
    navigate("/login");
  };

  return (
    <AuthPageContent
      title={isSuccess ? "Check your email" : "Forgot your password?"}
      description={
        isSuccess
          ? "We sent a password reset link to your email address."
          : "No worries, we'll send you reset instructions."
      }
    >
      <ForgotPasswordFormContainer
        onSuccess={() => setIsSuccess(true)}
        renderActions={({ isSubmitting, isValid, isSuccess, onSubmit }) => (
          <>
            {isSuccess ? (
              <div className="flex flex-col items-center justify-center gap-2">
                <Type variant="h5">Didn't recieve the email?</Type>
                <Button variant="link" onClick={onSubmit} className="p-0">
                  Click to resend.
                </Button>
              </div>
            ) : (
              <Button
                variant="primary"
                onClick={onSubmit}
                disabled={isSubmitting || !isValid}
                type="submit"
              >
                Resend Password
              </Button>
            )}
          </>
        )}
      />
      <Button variant="link" iconComponent={ArrowLeft} onClick={onCancel}>
        Back to Login
      </Button>
    </AuthPageContent>
  );
}

export default ForgotPasswordPage;
